import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps, useHistory} from 'react-router-dom';
import {getSortState} from 'react-jhipster';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PERMISSIONS} from 'app/config/constants';
import {hasAnyPermission} from 'app/shared/auth/permissions';
import {Button} from 'reactstrap';
import {IRootState} from 'app/shared/reducers';
import { useRegionLabels } from 'app/shared/hooks/useRegionLabels';
import { RegionDescriptionType } from 'app/shared/model/enumerations/region-description-type.model';
import {getAllEntities as getRegions, getEntities, getRegionsByType} from './region.reducer';
import {IRegion} from 'app/shared/model/region.model';
import {ITEMS_PER_PAGE} from 'app/shared/util/pagination.constants';
import {overridePaginationStateWithQueryParams} from 'app/shared/util/entity-utils';
import {RegionType} from "app/shared/model/enumerations/region-type.model";
import 'react-simple-tree-menu/dist/main.css';

import TreeList from 'react-treelist';
import 'react-treelist/build/css/index.css';

export interface IRegionProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const getCouncilName = (id, councilList) => {
  const council = councilList.find(v => v.id === id);
  return !council?
    { short:'', full: ''}
    :
    {
      short: council.name,
      full: (council.name + ' / ' + council?.parent?.name + ' / ' + council?.parent?.parent?.name + ' / ' + council?.parent?.parent?.parent?.name)
    };
}

export const Region = (props: IRegionProps) => {
  const {getLabel} = useRegionLabels();

  const history = useHistory();
  const regionTypeAndAttributes = [{type: 'STATE', color: 'green'}, {type: 'COUNCIL', color: 'blue'}, {
    type: 'DISTRICT',
    color: 'orange'
  }, {type: 'REGION', color: 'blue'}, {type: 'PROVINCE', color: 'orange'}, {type: 'COUNTRY', color: 'green'}]
  const buttonColor = {'REGION': 'green', 'DISTRICT': 'orange', 'COUNCIL': 'orange'}
  const buildTree = (region: IRegion, regions: Array<IRegion>, level: number) => {
    region['nodes'] = regions.filter(r => r.parentId === region.id)
    region['level'] = level
    region['label'] = region.name + " - " + region.type.toLowerCase()
    region['key'] = region.id

    level += 1

    for (const child of region.nodes) {
      buildTree(child, regions, level)
    }
  }


  const organizeRegions = (regionsByType) => {
    let regions: Array<IRegion> = []
    for (const [key, value] of Object.entries(regionsByType)) {
      regions = regions.concat(value)
    }

    const regionsWithChildren = regions.map(region => {
      region['nodes'] = regions.filter(r => r.parentId === region.id)
      return region
    })

    const countries = regionsWithChildren.filter(r => r.type === RegionType.COUNTRY);

    for (const country of countries) {
      buildTree(country, regionsWithChildren, 0)
    }
    return countries
  }

  /*
    const removeElement = (array, element) => {
      const index = array.indexOf(element)
      array.splice(index, 1)
    }
  */


  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE), props.location.search)
  );

  const fetchRegionsByType = () => {
    props.getRegionsByType();
  };

  useEffect(() => {
    fetchRegionsByType()
    props.getRegions()
  }, []);



  const { match, loading, totalItems, regionsByType} = props;
  let {regionList} = props;
  regionList  =  regionList.filter((ele)=>{
    return  props.isAdmin ? 1  : ele.id === props.userCountryId;
  })
  const getChildType = (id: string) => {
    if (typeof regionList !== 'undefined' && regionList.length > 0) {
      if (typeof regionList.find(region => region.id === id) !== "undefined") {
        switch (regionList.find(region => region.id === id).type) {
          case RegionType.COUNTRY:
            return RegionType.REGION
          case RegionType.REGION:
            return RegionType.DISTRICT
          case RegionType.DISTRICT:
            return RegionType.COUNCIL
          default:
            return ""
        }
      }
    }
  }

  const createChild = (id: string) => {
    const childType = getChildType(id)
    if (typeof childType !== "undefined") {
      const getChildLabel = (type: string) => {
        switch (type) {
          case RegionType.REGION:
            return getLabel(RegionDescriptionType.REGION)
          case RegionType.DISTRICT:
            return getLabel(RegionDescriptionType.DISTRICT)
          case RegionType.COUNCIL:
            return getLabel(RegionDescriptionType.COUNCIL)
          default:
            return type
        }
      }

      return (childType !== "" &&
        <Link key={id} style={{background: `${buttonColor[childType.toString()]}`}}
              to={`${match.url}/new?type=${childType}&parentId=${id}`}
              className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus"/>
          &nbsp; Add new {getChildLabel(childType)}
        </Link>
      )
    }
  }

  const itemViewLink = (id: string) => {
    return (
      <Button tag={Link} to={`${match.url}/${id}`} color="link" size="sm">
        {id}
      </Button>
    )
  }

  const typeFormatter = (type: string) => {
    return getLabel(type as RegionDescriptionType) || type;
  }

  const COLUMNS = [
    {'title': 'ID', 'field': 'id', 'type': 'string', 'formatter': itemViewLink, 'width': 400},
    {'title': 'Name', 'field': 'name', 'type': 'string'},
    {'title': 'Type', 'field': 'type', 'type': 'string', 'formatter': typeFormatter},
    {
      'title': '',
      'field': 'id',
      'type': 'string',
      'formatter': createChild,
      'width': 230
    }]

  return (
    <div>
      <h2 id="region-heading">
        {getLabel(RegionDescriptionType.REGION)}
        <Link to={`${match.url}/new?type=COUNTRY`} className="btn btn-primary float-right jh-create-entity"
              id="jh-create-entity">
          <FontAwesomeIcon icon="plus"/>
          &nbsp; Create new Country
        </Link>
      </h2>
      <div>
        {/* {regionsHierarchy && (<TreeMenu data={regionsHierarchy} onClickItem={({key, label}) => {*/}
        {/*  let id*/}
        {/*  if (key.includes("/")) {*/}
        {/*    id = key.split("/").slice(-1)*/}
        {/*  } else {*/}
        {/*    id = key*/}
        {/*  }*/}
        {/*  console.log(history.location.pathname)*/}
        {/*  history.replace(`${history.location.pathname}/${id}`)*/}
        {/* }}/>)}*/}
        {/* {regionTypeAndAttributes.map(value => {*/}
        {/*  return <Link key={value.type} style={{background:`${value.color}`}} to={`${match.url}/new?type=${value.type}`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">*/}
        {/*    <FontAwesomeIcon icon="plus"  />*/}
        {/*    &nbsp; Create new {value.type}*/}
        {/*  </Link>*/}
        {/* })*/}
        {/* }*/}

        {
          props.allEntitiesRefreshed ? (
            <TreeList
              data={regionList}
              columns={COLUMNS}
              // options={OPTIONS}
              // handlers={HANDLERS}
              id={'id'}
              parentId={'parentId'}></TreeList>
          ) : null
        }

      </div>
    </div>
  );
};

const mapStateToProps = ({region,authentication}: IRootState) => ({
  regionList: region.entities,
  loading: region.loading,
  totalItems: region.totalItems,
  regionsByType: region.regionsByType,
  updating: region.updating,
  updateSuccess: region.updateSuccess,
  allEntitiesRefreshed: region.allEntitiesRefreshed,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntities, getRegionsByType, getRegions,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Region);
